<template>
  <v-card
    class="overtile mx-auto rounded-0"
    color="#37383A"
    dark
    :outlined="getOutlined"
  >
    <v-img :src="quote.img.url">
      <div class="fill-height bottom-gradient"></div>
    </v-img>
  </v-card>
</template>

<script>
export default {
  name: "ImageTile",
  props: ["quote"],
  computed: {
    getOutlined() {
      return new Boolean(false);
    },
    getHeight() {
      const { mdAndDown } = this.$vuetify.breakpoint;
      return mdAndDown ? 200 : 400;
    },
    getWidth() {
      const { mdAndDown } = this.$vuetify.breakpoint;
      return mdAndDown ? 400 : 600;
    },
  },
};
</script>

<style lang="scss" scoped>
.overtile {
  position: relative;
  bottom: -100px;
  overflow: overlay;
  margin-top: -130px;
  box-shadow: -26px 29px 13px -6px rgba(0, 0, 0, 0.6);
}

.bottom-gradient {
  background-image: linear-gradient(
    to top,
    rgba(0, 0, 0, 0.1) 0%,
    transparent 72px
  );
}
</style> 